import { useParams as reactRouterUseParams } from 'react-router-dom';

export function useParams<T>(): T {
  return reactRouterUseParams() as unknown as T;
}
